import type { BaseElement } from 'slate';

import type { AlineContentBlock, SuggestedEdit, SuggestedFootersEdit } from '../../internal';

export enum FooterType {
  Default = 'default-footer',
  Even = 'even-footer',
  FirstPage = 'first-page-footer',
}

export interface BaseFooterElement extends BaseElement {
  children: AlineContentBlock[];
  type: FooterType;
  suggestedEdits?: SuggestedEdit[] | null;
}
export interface DefaultFooterElement extends BaseFooterElement {
  type: FooterType.Default;
}
export interface FirstPageFooterElement extends BaseFooterElement {
  type: FooterType.FirstPage;
}
export interface EvenFooterElement extends BaseFooterElement {
  type: FooterType.Even;
}
export type FooterElement = DefaultFooterElement | FirstPageFooterElement | EvenFooterElement;

export type FootersType = 'footers';
export const footersType: FootersType = 'footers';
export interface FootersElement extends BaseElement {
  children: FooterElement[];
  // Margin from the bottom of the page *in inches*.
  footerMargin: number;
  type: FootersType;
  suggestedEdits?: SuggestedFootersEdit[] | null;
}

export type FootersElementProps = Omit<FootersElement, 'children'>;
